import React from "react";
import { Dialog, Typography, DialogContent, Button } from "@mui/material";
import { VscFilePdf } from "react-icons/vsc";

export default function ConfirmDeleteDialog({ open, onClose, onConfirm, fileRemove, loadingRemove }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: "rgba(0,0,0,0.4)",
                        backdropFilter: "blur(5px)",
                    },
                },
            }}
        >
            <DialogContent style={{ padding: 30, position: "relative", borderRadius: 12 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2" align="center">
                    Confirmar eliminación
                </Typography>
                <br />
                <Typography variant="body1" align="center">
                    ¿Seguro que quieres eliminar este elemento?
                </Typography>
                <div style={{ width: "400px", marginLeft: "auto", marginRight: "auto", marginTop: "20px", display: "block" }}>
                    {(fileRemove.type === 'png' || fileRemove.type === 'jpg') && (
                        <img
                            src={fileRemove.url}
                            alt=""
                            loading="lazy"
                            style={{ width: "400px", marginLeft: "auto", marginRight: "auto", marginTop: "20px", display: "block" }}
                        />
                    )}
                    {fileRemove.type === 'pdf' && (
                        <VscFilePdf style={{ fontSize: "100px" }} />
                    )}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16, marginTop: 20 }}>
                    <div style={{ width: "50%" }}>
                        <Button
                            onClick={onClose}
                            variant="contained"
                            className="MuiButton-containedCancel"
                            fullWidth
                        >
                            Cancelar
                        </Button>
                    </div>
                    <div style={{ width: "50%" }}>
                        <Button
                            onClick={onConfirm}
                            color="primary"
                            variant="contained"
                            fullWidth
                            disabled={loadingRemove}
                        >
                            Eliminar
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
